import { useEffect, useState } from "react";
import FilterMenu from "./filter-menu";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Checkbox, Col, Row, Table, Modal, message } from "antd";
import { getDataLogin } from "../../../../utils/getDataLogin";
import API from "../../../../services/api-request";

const AccessControlList = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [listData, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [idActionPage, setIdActionPage] = useState({});

  const idPrivilege = getDataLogin().id_privilege;

  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const handleOk = () => {
    setConfirmLoading(true);

    API.Post(`control-list/update`, {
      id_privilege:
        parseInt(searchParams.get("id_privilege")) ??
        getDataLogin().id_privilege,
      // id_division: parseInt(searchParams.get("id_division")) || "",
      id_action_page: idActionPage,
    })
      .then((result) => {
        console.log(result);
        setOpen(false);
        setConfirmLoading(false);
        message.success("Success Update Access Control List");
        getACL(searchParams);
      })
      .catch((err) => {
        setConfirmLoading(false);
        message.info("Failed Update Access Control List");
        console.error(err);
      })
      .finally(() => {
        window.location.reload();
      });
  };

  const handleCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    const currentParams = new URLSearchParams(searchParams);

    if (!currentParams.has("id_privilege")) {
      currentParams.set("id_privilege", idPrivilege);

      setSearchParams(currentParams);
    }
  }, [searchParams, idPrivilege, setSearchParams]);

  const getACL = async (query) => {
    setIdActionPage({});
    setData([]);
    const queryString = new URLSearchParams(query).toString();

    setLoading(true);

    const replacedQS = queryString.replace(new RegExp("=", "g"), "/");

    API.Get(`control-list${query ? "/" + replacedQS : ""}`)
      .then((res) => {
        const newData = res?.data?.menu?.filter(
          (data) => data?.name !== "Privilege"
        );
        res?.data?.menu?.forEach((data) => {
          data.action_page.forEach((actionData) => {
            if (actionData.is_active === true) {
              addAction(`${actionData.id}`, "on");
            }
          });
          data.sub.forEach((subData) => {
            subData.action_page.forEach((actionData) => {
              if (actionData.is_active === true) {
                addAction(`${actionData.id}`, "on");
              }
            });
          });
        });
        setData(newData);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const queryParams = Object.fromEntries([...searchParams]);

    if (queryParams) {
      getACL(queryParams);
    }
  }, [searchParams]);

  const addAction = (id, status) => {
    setIdActionPage((prevState) => ({
      ...prevState,
      [id]: status,
    }));
  };

  const removeAction = (id) => {
    setIdActionPage((prevState) => {
      const newState = { ...prevState };
      delete newState[id];
      return newState;
    });
  };

  const columns = [
    {
      title: "Name",
      key: "name",
      width: 300,
      render: (data) => {
        return (
          <Row gutter={[8, 8]} style={{ flexDirection: "column" }}>
            <Col>{data.name}</Col>
            {data.sub.map((page, index) => {
              return (
                <Col key={index}>
                  <div style={{ marginLeft: "16px" }}>{page.name}</div>
                </Col>
              );
            })}
          </Row>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (data) => {
        return (
          <Row gutter={[8, 8]} style={{ flexDirection: "column" }}>
            <Row gutter={[8, 8]} align={"middle"}>
              {data.action_page.map((page, index) => {
                return (
                  <Col key={index}>
                    <Checkbox
                      defaultChecked={page.is_active}
                      onChange={(e) => {
                        if (e.target.checked) {
                          addAction(`${page.id}`, "on");
                        } else {
                          removeAction(`${page.id}`);
                        }
                      }}
                    >
                      {page.name}
                    </Checkbox>
                  </Col>
                );
              })}
            </Row>
            {data.sub.map((page) => {
              return (
                <Row gutter={[8, 8]} align={"middle"}>
                  {page.action_page.map((action, index) => {
                    return (
                      <Col key={index}>
                        <Checkbox
                          defaultChecked={action.is_active}
                          onChange={(e) => {
                            if (e.target.checked) {
                              addAction(`${action.id}`, "on");
                            } else {
                              removeAction(`${action.id}`);
                            }
                          }}
                        >
                          {action.name}
                        </Checkbox>
                      </Col>
                    );
                  })}
                </Row>
              );
            })}
          </Row>
        );
      },
    },
  ];

  const onClear = async (val) => {
    const queryParams = Object.fromEntries([...searchParams]);

    if (queryParams) {
      getACL(queryParams);
    }
  };

  return (
    <>
      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: "18px" }}
        gutter={[8, 8]}
      >
        <FilterMenu onClear={onClear} />

        <Col xl={2} lg={3} md={4} sm={6} xs={24}>
          <Button
            style={{ width: "100%" }}
            type="primary"
            onClick={() => showModal()}
          >
            Save
          </Button>
        </Col>
      </Row>

      <Table
        style={{ maxWidth: "100%", overflow: "auto" }}
        columns={columns}
        dataSource={listData}
        loading={loading}
        pagination={false}
        rowKey={(dataSource) => dataSource.id}
        // expandable={{
        //   expandedRowRender: (record) => {
        //     return record.sub.length < 1 ? (
        //       <></>
        //     ) : (
        //       <Table
        //         style={{ maxWidth: "100%", overflow: "auto" }}
        //         columns={columns}
        //         pagination={false}
        //         dataSource={record?.sub}
        //         rowKey={(dataSource) => dataSource.id}
        //       />
        //     );
        //   },
        // }}
      />

      <Modal
        title="Update Access Control List"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>Are you sure Update Access Control List?</p>
      </Modal>
    </>
  );
};

export default AccessControlList;
